import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import MentionList from './components/MentionList';
import { PluginKey } from '@tiptap/pm/state';
import { EXTENSION_TYPE_NAME } from './constants';
export const MentionPluginKey = new PluginKey(EXTENSION_TYPE_NAME);
export const suggestionExtensionConfig = {
    char: '@',
    pluginKey: MentionPluginKey,
    command: ({ editor, range, props })=>{
        var _nodeAfter_text, _window_getSelection;
        // increase range.to by one when the next node is of type "text"
        // and starts with a space character
        const nodeAfter = editor.view.state.selection.$to.nodeAfter;
        const overrideSpace = nodeAfter === null || nodeAfter === void 0 ? void 0 : (_nodeAfter_text = nodeAfter.text) === null || _nodeAfter_text === void 0 ? void 0 : _nodeAfter_text.startsWith(' ');
        if (overrideSpace) {
            range.to += 1;
        }
        editor.chain().focus().insertContentAt(range, [
            {
                type: EXTENSION_TYPE_NAME,
                attrs: props
            },
            {
                type: 'text',
                text: ' '
            }
        ]).run();
        (_window_getSelection = window.getSelection()) === null || _window_getSelection === void 0 ? void 0 : _window_getSelection.collapseToEnd();
    },
    allow: ({ state, range })=>{
        const $from = state.doc.resolve(range.from);
        const type = state.schema.nodes[EXTENSION_TYPE_NAME];
        return !!$from.parent.type.contentMatch.matchType(type);
    },
    render: ()=>{
        let component;
        let popup;
        return {
            onStart: (props)=>{
                component = new ReactRenderer(MentionList, {
                    props,
                    editor: props.editor
                });
                if (!props.clientRect) {
                    return;
                }
                popup = tippy('body', {
                    getReferenceClientRect: props.clientRect,
                    appendTo: ()=>document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    placement: 'bottom-start'
                });
            },
            onUpdate (props) {
                component.updateProps(props);
                if (!props.clientRect) {
                    return;
                }
                if (popup[0].state.isDestroyed) {
                    return;
                }
                popup[0].setProps({
                    getReferenceClientRect: props.clientRect
                });
            },
            onKeyDown (props) {
                var _component_ref;
                if (props.event.key === 'Escape') {
                    popup[0].hide();
                    return true;
                }
                if (props.event.key === ' ') {
                    props.editorCommands.daMentionTryMention(props.query, props.range);
                }
                return (_component_ref = component.ref) === null || _component_ref === void 0 ? void 0 : _component_ref.onKeyDown(props);
            },
            onExit () {
                if (!popup[0].state.isDestroyed) {
                    popup[0].destroy();
                }
                component.destroy();
            }
        };
    }
};

//# sourceMappingURL=suggestionExtensionConfig.js.map